<template>
  <div>
    <div class="content" v-if="!mobile" v-bind:class="{'content--100vh': redirectScreen}">
      <div v-if="!redirectScreen">
        <div class="container" v-if="parameters">
          <h1 class="content__header">Аренда автомобилей</h1>
          <RentForm v-if="presetsReady" />
          <div v-if="emptyParameters && readyShow">
            <div class="pt-5 pb-5 mt-5 mb-5 w-100 text-center">
              <h2>Пожалуйста, укажите место начала и окончания аренды</h2>
            </div>
          </div>
          <div v-else>
            <Catalog v-if="readyShow" />
            <CarItem v-if="car && readyShow" />
          </div>
        </div>
      </div>
      <div class="container" v-else>
        <div class="goto-payment">
          <div class="goto-payment__wrapper">
              <div class="goto-payment__item">Бронируем автомобиль</div>
              <div class="goto-payment__arrow"></div>
              <div class="goto-payment__item goto-payment__item--current">Перенаправляем<br> на страницу<span></span> оплаты</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-else>
      <div v-if="notReady">
        <MobileLoading />
      </div>
      <div v-else>
        <div class="container" v-if="!redirectScreen">
          <CarItemMob v-if="car" />
          <div v-show="!car">
            <RentFormMob />
            <div v-if="emptyParameters && readyShow && !isLocationChange && !isCalendarChange">
              <div class="pt-5 pb-5 mt-5 mb-5 w-100 text-center">
                <h2>Пожалуйста, укажите место начала и окончания аренды</h2>
              </div>
            </div>
            <div v-else>
              <CatalogMob v-if="readyShow" />
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <div class="goto-payment">
            <div class="goto-payment__wrapper">
                <div class="goto-payment__item">Бронируем автомобиль</div>
                <div class="goto-payment__arrow"></div>
                <div class="goto-payment__item goto-payment__item--current">Перенаправляем<br> на страницу<span></span> оплаты</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import RentForm from '@/components/RentForm';
import RentFormMob from '@/components/RentFormMob';
import Catalog from '@/components/Catalog';
import CatalogMob from '@/components/CatalogMob';
import CarItem from '@/components/CarItem';
import CarItemMob from '@/components/CarItemMob';
import Loader from '@/components/Loader';
import MobileLoading from '@/components/MobileLoading';
export default {
    name: 'Index',
    components: {
      RentForm,
      RentFormMob,
      Catalog,
      CatalogMob,
      Loader,
      CarItem,
      CarItemMob,
      MobileLoading,
    },
    data() {
      return {
        mobile: false,
        readyShow: false,
        width: 0,
        notReady: true,
        presetsReady: false,
      }
    },
    methods: {
      isMobile() {
        this.width = window.innerWidth;
        if( window.innerWidth <= 990 ) {
          this.mobile = true
        }
        else {
          this.mobile = false
        }
      },
    },
    created() {
      this.isMobile();
      window.addEventListener("resize", this.isMobile);
    },
    destroyed() {
      window.removeEventListener("resize", this.isMobile);
    },
    computed: {
      car() {
        return this.$store.getters.car;
      },
      parameters() {
        return this.$store.getters.parameters;
      },
      loading() {
        return this.$store.getters.locationsLoading;
      },
      redirectScreen() {
        return this.$store.getters.redirectScreen;
      },
      emptyParameters() {
        if (this.parameters.pick_up_datetime && this.parameters.drop_off_datetime && this.parameters.pick_up_location_id && this.parameters.drop_off_location_id || this.loading.cars) {
          return false;
        }
        return true;
      },
      isLocationChange() {
        return this.$store.getters.isLocationChange;
      },
      isCalendarChange() {
        return this.$store.getters.isCalendarChange;
      },
      isApp() {
        return this.$store.getters.isApp;
      },
      isAuth() {
        return this.$store.getters.isAuth;
      },
      user() {
        return this.$store.getters.isAuth;
      },
      presets() {
        return this.$store.getters.presets;
      },
    },
    mounted() {
      this.$store.dispatch('getPresets').finally(() => {
        this.presetsReady = true;
        if (this.isAuth) {
          this.$store.dispatch('getUser');
        }
        if (this.$route.query.vendor_id) {
          this.$store.dispatch('setVendor', this.$route.query.vendor_id);
        }
        if (this.$route.query.promocode) {
          this.$store.dispatch('setPromocode', this.$route.query.promocode);
        }
        this.$store.dispatch('getLocationsStart').then(() => {
          this.readyShow = true;
          if (this.$route.query.drop_off_datetime) {
            var endDate = this.$route.query.drop_off_datetime;
          } else {
            var endDate = moment(new Date(), 'DD.MM.YYYY').add(10, 'days').format('YYYY-MM-DD 12:00')
            let endDateFormated = moment(new Date(), 'DD.MM.YYYY').add(10, 'days').format('DD.MM.YYYY 12:00')
            this.$store.dispatch('changeEndDateTime', endDateFormated);
          }
          if (this.$route.query.pick_up_datetime) {
            let days = moment(this.$route.query.pick_up_datetime, 'YYYY-MM-DD HH:mm').diff(new Date(), 'hours');
            let configDays = '';
            if (this.presets && this.presets.calendar && this.presets.calendar.pick_up_datetime_offset_days) {
              configDays = this.presets.calendar.pick_up_datetime_offset_days;
            } else {
              configDays = 3;
            }
            let configH = configDays*24;
            if (days < configH) {
              let h = configDays - days;
              var startDate = moment(this.$route.query.pick_up_datetime, 'YYYY-MM-DD HH:mm').add(h, 'hours').format('YYYY-MM-DD HH:mm');
            } else {
              var startDate = this.$route.query.pick_up_datetime;
            }
          } else {
            var startDate = moment(new Date(), 'DD.MM.YYYY').add(7, 'days').format('YYYY-MM-DD 12:00')
            let startDateFormated = moment(new Date(), 'DD.MM.YYYY').add(7, 'days').format('DD.MM.YYYY 12:00')
            this.$store.dispatch('changeStartDateTime', startDateFormated);
          }
          let searchParameters = {
            pick_up_datetime: startDate,
            drop_off_datetime: endDate,
            pick_up_location_id: this.$route.query.pick_up_location_id,
            drop_off_location_id: this.$route.query.drop_off_location_id,
          }
          this.$store.dispatch('setLocationStartById', this.$route.query.pick_up_location_id).then(() => {
            this.readyShow = false;
            this.$store.dispatch('getLocationsEnd').then(() => {
              this.readyShow = true;
              this.$store.dispatch('setLocationEndById', this.$route.query.drop_off_location_id).then(() => {
                this.notReady = false;
                if (this.$route.query.cats) {
                  this.$store.dispatch('setCategories', this.$route.query.cats);
                }
                this.$store.dispatch('setSearchParameters', searchParameters).then(() => {
                  this.$store.dispatch('getCars').then((data) => {
                    if (this.$route.query.car) {
                      this.$store.dispatch('setCarById', this.$route.query.car);
                    }
                  });
                });
              });
            });
          })
        })
      })
    },
    watch: {
      '$route.query.drop_off_location_id': {
        handler(val) {
          this.$store.dispatch('clearVendor');
        },
        deep: true,
        immediate: true,
      },
      '$route.query.pick_up_location_id': {
        handler(val) {
          this.$store.dispatch('clearVendor');
        },
        deep: true,
        immediate: true,
      },
      '$route.query.car': {
        handler(val) {
          if (val == undefined) {
            this.$store.dispatch('clearCar');
          }
        },
        deep: true,
        immediate: true,
      },
      '$route.query.booking': {
        handler(val) {
          if (val == undefined) {
            this.$store.dispatch('setStep', 1);
          }
        },
        deep: true,
        immediate: true,
      },
      '$route.query.variants': {
        handler(val) {
          if (val == undefined) {
            this.$store.dispatch('clearVariants');
          }
        },
        deep: true,
        immediate: true,
      }
    },
}
</script>

<style>
  .content--100vh .container {
    min-height: calc(100vh - 202px) !important;
  }
  .autocomplete:before {
    content: '';
    display: block;
    width: 49px;
    z-index: 100;
    height: 32px;
    background-color: rgb(2,0,36);
    position: absolute;
    right: 0;
    top: 0;
    background: -webkit-gradient(linear, left top, right top, from(rgba(2,0,36,0)), to(rgba(254,208,31,1)));
    background: linear-gradient(90deg, rgba(254,208,31,0) 0%, rgb(254 208 31) 38%);
  }
  .autocomplete .mx-icon-clear {
    z-index: 200;
  }
  .rent-form__field-group--skeleton-mini:after {
    left: 24% !important;
  }
  .is-app .rent-form__field-group--skeleton:after {
    width: 77.4vw !important;
  }
</style>